export const stateNamesZh: Readonly<Record<string, string>> = {
  AL: '阿拉巴马州', AK: '阿拉斯加州', AZ: '亚利桑那州', AR: '阿肯色州', CA: '加利福尼亚州',
  CO: '科罗拉多州', CT: '康涅狄格州', DE: '特拉华州', DC: '哥伦比亚特区', FL: '佛罗里达州',
  GA: '佐治亚州', HI: '夏威夷州', ID: '爱达荷州', IL: '伊利诺伊州', IN: '印第安纳州',
  IA: '爱荷华州', KS: '堪萨斯州', KY: '肯塔基州', LA: '路易斯安那州', ME: '缅因州',
  MD: '马里兰州', MA: '马萨诸塞州', MI: '密歇根州', MN: '明尼苏达州', MS: '密西西比州',
  MO: '密苏里州', MT: '蒙大拿州', NE: '内布拉斯加州', NV: '内华达州', NH: '新罕布什尔州',
  NJ: '新泽西州', NM: '新墨西哥州', NY: '纽约州', NC: '北卡罗来纳州', ND: '北达科他州',
  OH: '俄亥俄州', OK: '俄克拉何马州', OR: '俄勒冈州', PA: '宾夕法尼亚州', RI: '罗得岛州',
  SC: '南卡罗来纳州', SD: '南达科他州', TN: '田纳西州', TX: '得克萨斯州', UT: '犹他州',
  VT: '佛蒙特州', VA: '弗吉尼亚州', WA: '华盛顿州', WV: '西弗吉尼亚州', WI: '威斯康星州',
  WY: '怀俄明州', AS: '美属萨摩亚', GU: '关岛', MP: '北马里亚纳群岛', PR: '波多黎各', VI: '美属维尔京群岛',
};

export const territoryCodes = new Set(['AS', 'GU', 'MP', 'PR', 'VI']);

export function localizedStateName(code: string, fallback: string): string {
  return stateNamesZh[code] ?? fallback;
}
